import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../store/store';
import { isFeatureEnabled, ORGANISATION_FEATURE } from '../../organisation/feature/helper';
import { InternalApiRole } from '../../api-internal';
import { getCustomerId } from '../../auth/authReducer';
import { DropdownOption } from '@salvapp/ui-components/build/dropdown/dropdown.types';
import { Dropdown } from '@salvapp/ui-components';
import { fetchRolesForFilters } from '../../users/userActions';
import { useMe } from '../../organisation/useMe';

interface Props {
  filterRoles?: Array<InternalApiRole>;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void;
  selectedRoles: DropdownOption[];
}

export const AlertFilterRolesSelector = ({
  filterRoles,
  setFieldValue,
  selectedRoles,
}: Props): React.JSX.Element | null => {
  const { features } = useMe();
  const filterPermissionsEnabled = isFeatureEnabled(ORGANISATION_FEATURE.FILTER_PERMISSIONS, features);

  const organisationId = useSelector((state: AppState) => Number(getCustomerId(state)), shallowEqual);
  const rolesForFilters = useSelector((state: AppState) => state.users.rolesForFilters, shallowEqual);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!filterPermissionsEnabled) {
      return;
    }
    if (rolesForFilters.length === 0) {
      dispatch(fetchRolesForFilters(organisationId));
    } else {
      setFieldValue(
        'roles',
        filterRoles?.map((role) => toDropdownOption(role))
      );
    }
  }, [rolesForFilters, dispatch, filterPermissionsEnabled]);

  if (!filterPermissionsEnabled) {
    return null;
  }

  const toDropdownOption = (role: InternalApiRole): DropdownOption => {
    const name = rolesForFilters.find((selectableRole) => role.id == selectableRole.id)?.name;
    return {
      key: String(role.id),
      label: name!,
      value: name!,
    };
  };

  return (
    <Row className='mt-4'>
      <Col md={12}>
        <label>Who can access these alerts</label>
        <div className='alert-filter-condition'>
          <Dropdown
            isMulti
            value={selectedRoles}
            size='medium'
            options={rolesForFilters.map((role) => toDropdownOption(role))}
            onChange={(newValue: DropdownOption[]) => {
              if (newValue) {
                setFieldValue('roles', newValue);
              }
            }}
          />
        </div>
      </Col>
    </Row>
  );
};
